import { axiosInstance } from './api';
import type { Paginated } from './types';

export interface CameraProviderDto {
  id: number;
  camera: number;
  name: string;
  ip_address: string;
  channel: string;
  username: string | null;
  /** Stored password — only returned by the DETAIL endpoint
   *  (`getProvider(id)`), never by `listProviders()`. List omits it
   *  so bulk responses don't fan passwords out unnecessarily. */
  password?: string | null;
  port: number | null;
  api_port: number;
  codec: string;
  force_tcp: boolean;
}

export interface CameraProviderCreatePayload {
  camera: number;
  name: string;
  ip_address: string;
  channel: string;
  username?: string | null;
  password?: string | null;
  port?: number | null;
  api_port: number;
  codec?: string;
  force_tcp?: boolean;
}

export const getProvider = (id: number | string) =>
  axiosInstance.get<CameraProviderDto>(`/core/api/providers/${id}/`);

export const listProviders = (zoneId: string, pageSize = 1000) =>
  axiosInstance.get<Paginated<CameraProviderDto>>(
    `/core/api/providers/?zone_id=${zoneId}&page_size=${pageSize}`,
  );

export const createProvider = (data: CameraProviderCreatePayload) =>
  axiosInstance.post<CameraProviderDto>('/core/api/providers/', data);

export const updateProvider = (id: number, data: Partial<CameraProviderCreatePayload>) =>
  axiosInstance.patch<CameraProviderDto>(`/core/api/providers/${id}/`, data);

export const deleteProvider = (id: number) =>
  axiosInstance.delete(`/core/api/providers/${id}/`);

export const detectProviderCodec = (id: number) =>
  axiosInstance.post<CameraProviderDto>(`/core/api/providers/${id}/detect-codec/`);
